<template>
  <div
    class="versus-row"
    :class="{ 'versus-row--multi': teams.length >= 3 }"
  >
    <template v-if="teams.length === 2">
      <div class="versus-row__side versus-row__side--left">
        <animated-player-names
          v-if="teams[0].length <= 2"
          ref="playerNames"
          :player1-name="teams[0][0].name"
          :player2-name="teams[0][1]?.name || ''"
          class="versus-row__name"
        />
        <template v-else>
          <span
            v-for="member in teams[0]"
            :key="member.id"
            class="text-body-1 text-truncate versus-row__name"
            style="line-height: 1.6;"
          >{{ member.name }}</span>
        </template>
      </div>
      <div
        class="versus-row__divider d-flex align-center justify-center font-weight-bold text-h6"
        :class="{ 'versus-row__divider--hidden': expanded }"
      >
        vs.
      </div>
      <div
        class="versus-row__side versus-row__side--right"
        :style="expanded ? { transform: 'translateY(' + innerShiftAmount + ')' } : undefined"
      >
        <animated-player-names
          v-if="teams[1].length <= 2"
          ref="playerNamesRight"
          :player1-name="teams[1][0].name"
          :player2-name="teams[1][1]?.name || ''"
          reverse
          class="versus-row__name"
        />
        <template v-else>
          <span
            v-for="member in teams[1]"
            :key="member.id"
            class="text-body-1 text-truncate versus-row__name"
            style="line-height: 1.6;"
          >{{ member.name }}</span>
        </template>
      </div>
    </template>
    <template v-else>
      <template v-for="(members, ti) in teams" :key="ti">
        <div class="d-flex flex-column align-center">
          <span
            v-for="member in members"
            :key="member.id"
            class="text-body-1 text-truncate versus-row__name"
            style="line-height: 1.6;"
          >{{ member.name }}</span>
        </div>
        <span
          v-if="ti < teams.length - 1"
          class="font-weight-bold text-h6 mx-1"
        >vs.</span>
      </template>
    </template>
  </div>
</template>

<script>
import AnimatedPlayerNames from "@/components/animated-player-names.vue";

export default {
  name: "VersusRow",
  components: {
    AnimatedPlayerNames
  },
  props: {
    teams: {
      type: Array,
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOnePlayerEach () {
      return this.teams[0]?.length === 1 && this.teams[1]?.length === 1;
    },
    innerShiftAmount () {
      return this.isOnePlayerEach ? "86px" : "64px";
    }
  },
  watch: {
    expanded (val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.playerNames) this.$refs.playerNames.measure();
          requestAnimationFrame(() => {
            if (this.$refs.playerNamesRight) this.$refs.playerNamesRight.measure();
          });
        });
      } else {
        if (this.$refs.playerNames) this.$refs.playerNames.close();
        if (this.$refs.playerNamesRight) this.$refs.playerNamesRight.close();
      }
    }
  }
};
</script>

<style scoped>
.versus-row {
  display: flex;
  align-items: stretch;
  min-height: 45px;
}
.versus-row--multi {
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
  flex-wrap: wrap;
}
.versus-row__side {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.versus-row__side--left {
  text-align: center;
}
.versus-row__side--right {
  text-align: center;
  transition: transform .3s ease;
}
.versus-row__divider {
  flex-shrink: 0;
  padding: 0 8px;
  transition: opacity .3s ease;
}
.versus-row__divider--hidden {
  opacity: 0;
}
.versus-row__name {
  max-width: 135px;
}
.versus-row__name :deep(.player-name-1),
.versus-row__name :deep(.player-name-2) {
  max-width: 135px;
}
</style>
